import React, { useContext, useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import { MdDownload, MdPrint, MdQrCode2, MdPeople, MdSearch } from 'react-icons/md';
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from 'html2canvas';
import './IDCard.css';
const EmployeeCard = ({ cardUser, adminSignature }) => {
  const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.split(' ');
    if (parts.length >= 2) return parts[0][0] + parts[parts.length - 1][0];
    return name[0];
  };

  const getEmployeeId = (id) => {
    if (!id) return 'JT000';
    return `JT${String(id).padStart(3, '0')}`;
  };

  return (
    <div className="idcard premium">
      <div className="premium-border"></div>
      <div className="idcard-accent-bar"></div>
      <div className="idcard-content">
        <div className="idcard-header-section">
          <div className="idcard-logo-premium">
            <div className="logo-icon">
              <img src="/Gemini_Generated_Image_r13e3ur13e3ur13e.png" alt="JiruuTech Logo" className="logo-img" />
            </div>
            <div className="logo-text-container">
              <span className="logo-text">JIRUU</span>
              <span className="logo-text-sub">TECHNOLOGIES PLC</span>
            </div>
          </div>
          <div className="idcard-title-premium">
            <span className="title-main">EMPLOYEE</span>
            <span className="title-sub">ID CARD</span>
          </div>
        </div>

        <div className="premium-divider"></div>

        <div className="idcard-body-premium">
          <div className="idcard-photo-premium">
            <div className="photo-frame">
              {cardUser?.avatar_url ? (
                <img src={cardUser.avatar_url} alt={cardUser.full_name || cardUser.username} />
              ) : (
                <div className="photo-placeholder">
                  {getInitials(cardUser?.full_name || cardUser?.username)}
                </div>
              )}
            </div>
            <img src="/jiruutech_stamp.png" alt="Official Seal" className="idcard-stamp" />
          </div>

          <div className="idcard-info-premium">
            <div className="employee-name">{cardUser?.full_name || cardUser?.username || 'Employee Name'}</div>
            <div className="employee-title">{cardUser?.job_title || 'Team Member'}</div>
            <div className="employee-id">ID: {getEmployeeId(cardUser?.id)}</div>
            <div className="info-grid">
              <div className="info-row">
                <div className="info-label">Phone</div>
                <div className="info-value">{cardUser?.phone || 'N/A'}</div>
              </div>
              <div className="info-row">
                <div className="info-label">Date of Birth</div>
                <div className="info-value">{cardUser?.date_of_birth
                  ? new Date(cardUser.date_of_birth).toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })
                  : 'N/A'}</div>
              </div>
              <div className="info-row">
                <div className="info-label">Address</div>
                <div className="info-value">{cardUser?.address || 'N/A'}</div>
              </div>
              <div className="info-row">
                <div className="info-label">Sex</div>
                <div className="info-value">{cardUser?.sex || 'N/A'}</div>
              </div>
            </div>
          </div>

          <div className="idcard-qr-premium">
            <div className="qr-code">
              <QRCodeSVG
                value="https://jiruutech.com"
                size={50}
                bgColor="white"
                fgColor="#1E40AF"
                level="M"
              />
            </div>
            <div className="qr-bottom-info">
              <div className="info-row location-info">
                <div className="info-label">Expiry Date</div>
                <div className="info-value">DEC 2027</div>
              </div>
              <div className="info-row location-info">
                <div className="info-label">Nationality</div>
                <div className="info-value">{cardUser?.nationality || 'Ethiopian'}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="idcard-footer-premium">
          <div className="footer-left">
            <div className="footer-sig-row">
              <span className="footer-label">AUTHORIZED SIGNATURE</span>
              <div className="signature-stamp-container">
                {adminSignature ? (
                  <img src={adminSignature} alt="Signature" className="card-signature-img" />
                ) : (
                  <div className="signature-line"></div>
                )}
              </div>
            </div>
          </div>
          <div className="footer-right">
            <div className="validity">
              <span className="validity-label">VALID UNTIL</span>
              <span className="validity-date">DEC 2027</span>
            </div>
          </div>
        </div>

        <div className="premium-pattern pattern-1"></div>
        <div className="premium-pattern pattern-2"></div>
        <div className="premium-pattern pattern-3"></div>
        <div className="holographic-overlay"></div>
      </div>
    </div>
  );
};

// Download helper
const downloadCard = async (cardElement, cardUser) => {
  if (!cardElement) return;

  const getEmployeeId = (id) => `JT${String(id || 0).padStart(3, '0')}`;
  const scale = 4;

  // ── Helper: load an image and draw it cover-cropped onto a canvas context ──
  const drawCover = (ctx, img, dx, dy, dw, dh) => {
    const imgAspect = img.naturalWidth / img.naturalHeight;
    const boxAspect = dw / dh;
    let sx, sy, sw, sh;
    if (imgAspect > boxAspect) {
      sh = img.naturalHeight;
      sw = sh * boxAspect;
      sx = (img.naturalWidth - sw) / 2;
      sy = 0;
    } else {
      sw = img.naturalWidth;
      sh = sw / boxAspect;
      sx = 0;
      sy = (img.naturalHeight - sh) / 2;
    }
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
  };

  const loadImage = (src) => new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = src;
  });

  // ── Collect image sources BEFORE cloning ──
  const photoImgEl = cardElement.querySelector('.photo-frame img');
  const logoImgEl  = cardElement.querySelector('.logo-img');
  const stampImgEl = cardElement.querySelector('.idcard-stamp');
  const photoSrc   = photoImgEl?.src || null;
  const logoSrc    = logoImgEl?.src  || null;
  const stampSrc   = stampImgEl?.src || null;

  // Collect position of photo frame, logo and stamp relative to the card element
  const cardRect  = cardElement.getBoundingClientRect();
  const photoRect = photoImgEl ? photoImgEl.closest('.photo-frame').getBoundingClientRect() : null;
  const logoRect  = logoImgEl  ? logoImgEl.closest('.logo-icon').getBoundingClientRect()    : null;
  const stampRect = stampImgEl ? stampImgEl.getBoundingClientRect() : null;

  // ── Clone and hide images so html2canvas doesn't blur them ──
  const clonedCard = cardElement.cloneNode(true);
  clonedCard.style.background = 'transparent';
  clonedCard.style.transform = 'none';
  clonedCard.style.animation = 'none';
  clonedCard.style.transition = 'none';
  clonedCard.style.width = '550px';
  clonedCard.style.height = '330px';
  clonedCard.style.maxWidth = '550px';
  clonedCard.style.position = 'fixed';
  clonedCard.style.left = '-9999px';
  clonedCard.style.top = '0';
  clonedCard.style.zIndex = '-1';
  clonedCard.style.boxShadow = 'none';

  clonedCard.querySelector('.holographic-overlay')?.remove();
  clonedCard.querySelectorAll('.premium-pattern').forEach(p => p.remove());
  clonedCard.querySelector('.premium-border')?.remove();

  // Hide the actual images — html2canvas will leave transparent holes
  const clonedPhotoImg = clonedCard.querySelector('.photo-frame img');
  const clonedLogoImg  = clonedCard.querySelector('.logo-img');
  const clonedStampImg = clonedCard.querySelector('.idcard-stamp');
  if (clonedPhotoImg) clonedPhotoImg.style.visibility = 'hidden';
  if (clonedLogoImg)  clonedLogoImg.style.visibility  = 'hidden';
  if (clonedStampImg) clonedStampImg.style.visibility = 'hidden';

  document.body.appendChild(clonedCard);
  await new Promise(resolve => setTimeout(resolve, 300));

  // ── Capture card layout via html2canvas (no images) ──
  const layoutCanvas = await html2canvas(clonedCard, {
    scale,
    useCORS: true,
    allowTaint: true,
    logging: false,
    width: 550,
    height: 330,
    backgroundColor: null,
  });

  document.body.removeChild(clonedCard);

  // ── Build background canvas with rounded corners ──
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width  = 550 * scale;
  tempCanvas.height = 330 * scale;
  const tempCtx = tempCanvas.getContext('2d');

  const gradient = tempCtx.createLinearGradient(0, 0, tempCanvas.width, tempCanvas.height);
  gradient.addColorStop(0,   '#0F172A');
  gradient.addColorStop(0.5, '#1E293B');
  gradient.addColorStop(1,   '#334155');
  tempCtx.fillStyle = gradient;
  tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

  const r = 24 * scale;
  tempCtx.globalCompositeOperation = 'destination-in';
  tempCtx.beginPath();
  tempCtx.moveTo(r, 0);
  tempCtx.lineTo(tempCanvas.width - r, 0);
  tempCtx.quadraticCurveTo(tempCanvas.width, 0, tempCanvas.width, r);
  tempCtx.lineTo(tempCanvas.width, tempCanvas.height - r);
  tempCtx.quadraticCurveTo(tempCanvas.width, tempCanvas.height, tempCanvas.width - r, tempCanvas.height);
  tempCtx.lineTo(r, tempCanvas.height);
  tempCtx.quadraticCurveTo(0, tempCanvas.height, 0, tempCanvas.height - r);
  tempCtx.lineTo(0, r);
  tempCtx.quadraticCurveTo(0, 0, r, 0);
  tempCtx.closePath();
  tempCtx.fill();
  tempCtx.globalCompositeOperation = 'source-over';

  // Draw the html2canvas layout on top
  tempCtx.drawImage(layoutCanvas, 0, 0);

  // ── Draw images directly at full quality ──
  if (photoSrc && photoRect && cardRect) {
    const photoImg = await loadImage(photoSrc);
    if (photoImg) {
      const pad = 2 * scale; // photo-frame padding is 2px
      const dx = (photoRect.left - cardRect.left) * scale + pad;
      const dy = (photoRect.top  - cardRect.top)  * scale + pad;
      const dw = photoRect.width  * scale - pad * 2;
      const dh = photoRect.height * scale - pad * 2;

      // Clip to rounded rect matching photo-frame inner border-radius (12px)
      const pr = 12 * scale;
      tempCtx.save();
      tempCtx.beginPath();
      tempCtx.moveTo(dx + pr, dy);
      tempCtx.lineTo(dx + dw - pr, dy);
      tempCtx.quadraticCurveTo(dx + dw, dy, dx + dw, dy + pr);
      tempCtx.lineTo(dx + dw, dy + dh - pr);
      tempCtx.quadraticCurveTo(dx + dw, dy + dh, dx + dw - pr, dy + dh);
      tempCtx.lineTo(dx + pr, dy + dh);
      tempCtx.quadraticCurveTo(dx, dy + dh, dx, dy + dh - pr);
      tempCtx.lineTo(dx, dy + pr);
      tempCtx.quadraticCurveTo(dx, dy, dx + pr, dy);
      tempCtx.closePath();
      tempCtx.clip();
      drawCover(tempCtx, photoImg, dx, dy, dw, dh);
      tempCtx.restore();
    }
  }

  if (logoSrc && logoRect && cardRect) {
    const logoImg = await loadImage(logoSrc);
    if (logoImg) {
      const pad = 0; // logo-icon has no padding, just overflow:hidden
      const dx = (logoRect.left - cardRect.left) * scale + pad;
      const dy = (logoRect.top  - cardRect.top)  * scale + pad;
      const dw = logoRect.width  * scale - pad * 2;
      const dh = logoRect.height * scale - pad * 2;

      const lr = 8 * scale;
      tempCtx.save();
      tempCtx.beginPath();
      tempCtx.moveTo(dx + lr, dy);
      tempCtx.lineTo(dx + dw - lr, dy);
      tempCtx.quadraticCurveTo(dx + dw, dy, dx + dw, dy + lr);
      tempCtx.lineTo(dx + dw, dy + dh - lr);
      tempCtx.quadraticCurveTo(dx + dw, dy + dh, dx + dw - lr, dy + dh);
      tempCtx.lineTo(dx + lr, dy + dh);
      tempCtx.quadraticCurveTo(dx, dy + dh, dx, dy + dh - lr);
      tempCtx.lineTo(dx, dy + lr);
      tempCtx.quadraticCurveTo(dx, dy, dx + lr, dy);
      tempCtx.closePath();
      tempCtx.clip();
      drawCover(tempCtx, logoImg, dx, dy, dw, dh);
      tempCtx.restore();
    }
  }

  // ── Draw stamp LAST so it sits on top of the photo ──
  if (stampSrc && stampRect && cardRect) {
    const stampImg = await loadImage(stampSrc);
    if (stampImg) {
      const dx = (stampRect.left - cardRect.left) * scale;
      const dy = (stampRect.top  - cardRect.top)  * scale;
      const dw = stampRect.width  * scale;
      const dh = stampRect.height * scale;
      const cx = dx + dw / 2;
      const cy = dy + dh / 2;
      tempCtx.save();
      tempCtx.globalAlpha = 0.88;
      tempCtx.imageSmoothingEnabled = true;
      tempCtx.imageSmoothingQuality = 'high';
      tempCtx.translate(cx, cy);
      tempCtx.rotate(-8 * Math.PI / 180);
      // Draw at natural image size to avoid upscale blur
      const nw = stampImg.naturalWidth;
      const nh = stampImg.naturalHeight;
      tempCtx.drawImage(stampImg, 0, 0, nw, nh, -dw / 2, -dh / 2, dw, dh);
      tempCtx.restore();
    }
  }

  const finalCanvas = document.createElement('canvas');
  const padding = 60 * scale;
  finalCanvas.width  = tempCanvas.width  + padding * 2;
  finalCanvas.height = tempCanvas.height + padding * 2;
  const ctx = finalCanvas.getContext('2d');
  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);
  ctx.drawImage(tempCanvas, padding, padding);

  return new Promise((resolve) => {
    finalCanvas.toBlob((blob) => {
      if (!blob) { resolve(false); return; }
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${cardUser?.username || 'employee'}-id-card-${getEmployeeId(cardUser?.id)}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      resolve(true);
    }, 'image/png', 1.0);
  });
};

// ─── Main Component ───────────────────────────────────────────────────────────
const IDCard = () => {
  const { user } = useContext(AuthContext);
  const cardRef = useRef(null);
  const [downloading, setDownloading] = useState(false);
  const [downloadingId, setDownloadingId] = useState(null);

  // Admin state
  const [allUsers, setAllUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [adminSignature, setAdminSignature] = useState(null);
  const cardRefs = useRef({});

  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    if (isAdmin) {
      fetchAllUsers();
    }
    fetchAdminSignature();
  }, [isAdmin]);

  const fetchAdminSignature = async () => {
    try {
      const res = await axios.get('/api/users/admin-signature');
      setAdminSignature(res.data.signature_url);
    } catch (error) {
      console.error('Error fetching admin signature:', error);
    }
  };

  useEffect(() => {
    if (searchTerm) {
      setFilteredUsers(allUsers.filter(u =>
        (u.full_name || u.username).toLowerCase().includes(searchTerm.toLowerCase()) ||
        (u.job_title || '').toLowerCase().includes(searchTerm.toLowerCase())
      ));
    } else {
      setFilteredUsers(allUsers);
    }
  }, [searchTerm, allUsers]);

  const fetchAllUsers = async () => {
    setLoading(true);
    try {
      const res = await axios.get('/api/users');
      setAllUsers(res.data);
      setFilteredUsers(res.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  // Download for regular user
  const handleDownload = async () => {
    if (!cardRef.current) return;
    setDownloading(true);
    try {
      const cardElement = cardRef.current.querySelector('.idcard.premium');
      await downloadCard(cardElement, user);
    } catch (error) {
      console.error('Error downloading card:', error);
      alert('Failed to download card. Please try again.');
    } finally {
      setDownloading(false);
    }
  };

  // Download for specific user (admin)
  const handleDownloadUser = async (cardUser) => {
    setDownloadingId(cardUser.id);
    try {
      const cardElement = cardRefs.current[cardUser.id]?.querySelector('.idcard.premium');
      await downloadCard(cardElement, cardUser);
    } catch (error) {
      console.error('Error downloading card:', error);
      alert('Failed to download card. Please try again.');
    } finally {
      setDownloadingId(null);
    }
  };

  const handlePrint = () => window.print();

  // ── Admin View ──────────────────────────────────────────────────────────────
  if (isAdmin) {
    return (
      <div className="app-container">
        <Sidebar />
        <div className="main-content idcard-main">
          <div className="idcard-page">
            <div className="idcard-header">
              <div>
                <h1><MdPeople style={{ verticalAlign: 'middle', marginRight: 8 }} />All Employee ID Cards</h1>
                <p className="idcard-subtitle">View and download ID cards for all employees</p>
              </div>
              <div className="admin-search-box">
                <MdSearch className="search-icon" />
                <input
                  type="text"
                  placeholder="Search employees..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            {loading ? (
              <div className="loading">Loading employee cards...</div>
            ) : (
              <div className="admin-cards-grid">
                {filteredUsers.map(cardUser => (
                  <div key={cardUser.id} className="admin-card-item">
                    <div className="admin-card-info">
                      <span className="admin-card-name">{cardUser.full_name || cardUser.username}</span>
                      <span className="admin-card-role">{cardUser.job_title || cardUser.role}</span>
                    </div>
                    <div
                      className="idcard-container"
                      ref={el => cardRefs.current[cardUser.id] = el}
                    >
                      <div className="idcard-wrapper">
                        <EmployeeCard cardUser={cardUser} adminSignature={adminSignature} />
                      </div>
                    </div>
                    <div className="admin-card-actions">
                      <button
                        className="action-btn download-btn"
                        onClick={() => handleDownloadUser(cardUser)}
                        disabled={downloadingId === cardUser.id}
                      >
                        <MdDownload />
                        {downloadingId === cardUser.id ? 'Generating...' : 'Download'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ── Regular User View ───────────────────────────────────────────────────────
  return (
    <div className="app-container">
      <Sidebar />
      <div className="main-content idcard-main">
        <div className="idcard-page">
          <div className="idcard-header">
            <div>
              <h1>Employee ID Card</h1>
              <p className="idcard-subtitle">Your premium digital employee identification</p>
            </div>
            <div className="idcard-actions">
              <button
                className="action-btn download-btn"
                onClick={handleDownload}
                disabled={downloading}
              >
                <MdDownload />
                {downloading ? 'Generating...' : 'Download Card'}
              </button>
              <button className="action-btn print-btn" onClick={handlePrint}>
                <MdPrint />
                Print Card
              </button>
            </div>
          </div>

          <div className="idcard-content-wrapper">
            <div className="idcard-container" ref={cardRef}>
              <div className="idcard-wrapper">
                <EmployeeCard cardUser={user} adminSignature={adminSignature} />
              </div>
            </div>
          </div>

          <div className="idcard-note premium-note">
            <div className="note-icon"><MdQrCode2 /></div>
            <div className="note-content">
              <p><strong>Premium Employee ID Card</strong></p>
              <p>This is your official employee identification. Keep it secure and report any loss immediately to HR at jiruutech@gmail.com.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IDCard;
